import { LANDING_PAGE_JOIN_API_PATH } from './constants';

type RedirectThroughLandingPageJoinOptions = {
    /** Contentful `target`; defaults to same-tab when omitted / not `_blank`. */
    openInNewTab?: boolean;
};

/**
 * Top-level POST to `/api/join` so the browser applies the handoff Set-Cookie and
 * follows the API's 303 Location (LP Header join URL from Contentful) with GET.
 * Referer supplies the landing page path used to seal the handoff cookie.
 *
 * `fetch` cannot do this reliably for cross-origin redirects, so we use a form submit.
 * Must be 303 (not 307): 307 would re-POST the join URL and LP would 404.
 */
export const redirectThroughLandingPageJoin = (
    options: RedirectThroughLandingPageJoinOptions = {},
): void => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = LANDING_PAGE_JOIN_API_PATH;
    form.style.display = 'none';

    if (options.openInNewTab) {
        form.target = '_blank';
        // Never add `noreferrer`: the join route reads the landing page path from Referer.
        form.rel = 'noopener';
    }

    document.body.appendChild(form);
    form.submit();
    form.remove();
};
